import { Progress, theme } from "antd";
import { useEffect, useState } from "react";

/**
 * Line progress bar shown during cross-route navigation (centered in overlay).
 * Animates below 100% so the neutral trail stays visible (not all-blue).
 */
export const TopProgressBar = () => {
  const { token } = theme.useToken();
  const [percent, setPercent] = useState(12);

  useEffect(() => {
    const interval = setInterval(() => {
      setPercent((current) => {
        if (current >= 88) {
          return 12;
        }
        return Math.min(current + 6 + Math.random() * 12, 88);
      });
    }, 220);

    return () => clearInterval(interval);
  }, []);

  return (
    <Progress
      percent={percent}
      status="active"
      showInfo={false}
      strokeLinecap="round"
      strokeColor={token.colorPrimary}
      trailColor={token.colorBorder}
      size={["100%", 4]}
      aria-label="Page loading"
    />
  );
};
